// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const productSlice = createSlice({
    name: 'products',
    initialState: {
        sharedProducts: []
    },
    reducers: {
        updateSharedProducts: (state, action) => {
            state.sharedProducts = action.payload
        }
    }
})

export const { updateSharedProducts } = productSlice.actions
export default productSlice.reducer
